export default "__VITE_ASSET__DdUDGyI4__"